// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.theme-light .cases {
  padding: 20px 70px;
  background-color: #f6f3f3;
  flex-direction: column;
  min-height: 800px;
  position: relative;
}
@media (max-width: 480px) {
  .theme-light .cases {
    padding: 10px;
  }
}
@media (max-width: 960px) {
  .theme-light .cases {
    padding: 20px;
  }
}
.theme-dark .cases {
  padding: 20px 70px;
  background-color: #333;
  flex-direction: column;
  min-height: 800px;
  position: relative;
}
@media (max-width: 480px) {
  .theme-dark .cases {
    padding: 10px;
  }
}
@media (max-width: 960px) {
  .theme-dark .cases {
    padding: 20px;
  }
}`, "",{"version":3,"sources":["webpack://./src/style.scss","webpack://./src/pages/cases/cases.scss"],"names":[],"mappings":"AAqBI;ECjBA,kBAAA;EACA,yBAAA;EACA,sBAAA;EACA,iBAAA;EACA,kBAAA;AAFJ;ADqCE;EAtBE;ICVE,aAAA;EADJ;AACF;ADqCE;EA3BE;ICNE,aAAA;EAAJ;AACF;ADKI;ECjBA,kBAAA;EACA,sBAAA;EACA,sBAAA;EACA,iBAAA;EACA,kBAAA;AAeJ;ADoBE;EAtBE;ICVE,aAAA;EAgBJ;AACF;ADoBE;EA3BE;ICNE,aAAA;EAiBJ;AACF","sourcesContent":["$themes: (\n  light: (\n    textColor: #000,\n    bg: white,\n    logo: #0B4855,\n    bgSoft: #f6f3f3,\n    textColorSoft: #555,\n    border: lightgray,\n  ),\n  dark: (\n    textColor: #fffef9,\n    bg: #222,\n    logo: rgb(78, 217, 113),\n    bgSoft: #333,\n    textColorSoft: #d1d0c9,\n    border: #444,\n  ),\n);\n\n@mixin themify($themes) {\n  @each $theme, $map in $themes {\n    .theme-#{$theme} & {\n      $theme-map: () !global;\n      @each $key, $submap in $map {\n        $value: map-get(map-get($themes, $theme), \"#{$key}\");\n        $theme-map: map-merge(\n          $theme-map,\n          (\n            $key: $value,\n          )\n        ) !global;\n      }\n      @content;\n      $theme-map: null !global;\n    }\n  }\n}\n\n@function themed($key) {\n  @return map-get($theme-map, $key);\n}\n\n@mixin mobile {\n  @media (max-width: 480px) {\n    @content;\n  }\n}\n@mixin tablet {\n  @media (max-width: 960px) {\n    @content;\n  }\n}\n","@import \"../../style.scss\";\n\n.cases{\n  @include themify($themes) {\n    padding: 20px 70px;\n    background-color: themed(\"bgSoft\");\n    flex-direction: column;\n    min-height: 800px;\n    position: relative;\n\n    @include mobile {\n      padding: 10px;\n    }\n\n    @include tablet{\n      padding: 20px;\n    }\n\n    \n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
